module.exports = __webpack_public_path__ + "img/fc17dec.png";